import * as React from "react";
import { forwardRef } from "react";
const SvgLogoPagerDuty = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "15 15 66 66",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "#06AC38",
	d: "M16 16h64v64H16z"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.9327 58.1074h-6.2661v11.4231h6.2661V58.1074Zm17.3335-29.3465c-3.3636-1.795-5.6964-2.0942-11.203-2.0942H34.6666v26.0012h12.3423c4.9098 0 8.5718-.2992 11.7998-2.4478 3.5264-2.3391 5.3438-6.2284 5.3438-10.716 0-4.8684-2.2514-8.7577-5.8863-10.7432Zm-9.8196 18.4674h-7.5139v-14.986l7.0799-.0544c6.456-.0816 9.684 2.203 9.684 7.3706 0 5.5484-3.9875 7.6698-9.25 7.6698Z",
	fill: "#fff"
}));
const ForwardRef = forwardRef(SvgLogoPagerDuty);
export default ForwardRef;
